let env = window.location.hostname
    .toLowerCase()
    .split( '.' )
    .find( function ( chunk ) {
        return [ 'ci', 'dev', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
    } );
if ( window.location.origin.indexOf( '://localhost' ) >= 0 ) {
    env = 'qa';
}

function getURL( url ) {
    return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const idURL = getURL( 'https://(env.)api.biw.cloud/v1/id' );
export const cashierUrl = getURL( 'https://(env.)api.biw.cloud/v1/cashier' );
export const solutionsUrl = getURL( 'https://(env.)api.biw.cloud/solutionapi/services/v1' );
export const companyURL = getURL( 'https://(env.)api.biw.cloud/v1/company-setup' );
export const profileUrl = getURL( 'https://(env.)api.biw.cloud/v1/profile' );
export const rosterUrl = getURL( 'https://(env.)api.biw.cloud/v1/roster' );
export const cmxUrl = getURL( 'https://(env.)api.biw.cloud/v2/cmx' );
export const ecardUrl = getURL( 'https://(env.)api.biw.cloud/v1/ecard-wrapper' );
